import { CheckIcon } from "./icons";
import { OutsourceDiagram } from "./OutsourceDiagram";
import { SectionHeader } from "./SectionHeader";
import type { Theme } from "./theme";

const ITEMS = [
  "define roles clearly",
  "assess candidates consistently",
  "collaborate effectively across stakeholders",
  "make confident, evidence-based decisions",
];

export function WhatRarionDoes({ theme }: { theme: Theme }) {
  return (
    <section
      id="what"
      style={{
        padding: "120px 0",
        borderTop: `1px solid ${theme.border}`,
        background: theme.surface,
      }}
    >
      <SectionHeader
        theme={theme}
        kicker="What Rarion does"
        title="We give your team the capability you currently outsource."
      />
      <div
        style={{
          maxWidth: 1200,
          margin: "0 auto",
          padding: "0 40px",
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: 64,
        }}
      >
        <div>
          <p style={{ fontSize: 17, color: theme.fgMute, lineHeight: 1.6, margin: 0 }}>
            Rarion allows your internal team to deliver search-quality hiring outcomes without
            relying on external agencies. It provides the structure, tools, and shared frameworks
            needed to:
          </p>
          <ul style={{ listStyle: "none", padding: 0, margin: "28px 0 0" }}>
            {ITEMS.map((t, i) => (
              <li
                key={t}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 14,
                  padding: "14px 0",
                  fontSize: 17,
                  color: theme.fg,
                  borderBottom: i < ITEMS.length - 1 ? `1px solid ${theme.border}` : "none",
                }}
              >
                <span
                  style={{
                    width: 22,
                    height: 22,
                    borderRadius: 11,
                    background: theme.accentSoft,
                    color: theme.accentFg,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <CheckIcon />
                </span>
                {t}
              </li>
            ))}
          </ul>
          <p
            style={{
              fontSize: 15,
              color: theme.fgMute,
              lineHeight: 1.6,
              marginTop: 28,
              fontStyle: "italic",
            }}
          >
            Replace agency dependency with internal capability, without losing speed or confidence.
          </p>
        </div>
        <OutsourceDiagram theme={theme} />
      </div>
    </section>
  );
}
